"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
function default_1(props) {
    const { size } = props;
    return (0, react_1.css) `
        &:hover {
            border-color: var(--input-border-color-hovered);
        }

        .input__control {
            width: 100%;
            box-sizing: border-box;
            outline: 0;
            font-family: var(--main-font);
            font-size: var(--input-${size}-fontSize);
            color: var(--text-color);
            height: var(--input-${size}-height);
            display: flex;
            align-items: center;
            border: 2px solid rgba(0, 0, 0, 0.2);
            transition: 0.1s ease-out;
            transition-property: border-color, border-width;
            padding: 0 0.53em;
            background-color: var(--input-control-bg-color);
        }

        .input__control_bottomBordered {
            border: none;
            border-bottom: 2px solid var(--input-control-bottom-border-color);
            padding: 0;
        }

        .input__control::placeholder {
            color: var(--input-control-placeholder-color);
        }

        .input__control::-moz-placeholder {
            color: var(--input-control-placeholder-color);
            opacity: 1; /*В firefox полупрозрачный по умолчанию*/
        }

        // states

        .input__control:active,
        .input__control:focus {
            border: 2px solid var(--view-default-fill-color-action);
        }

        .input__control.input__control_bottomBordered:active,
        .input__control.input__control_bottomBordered:focus {
            border: none;
            border-bottom: 2px solid var(--input-control-bottom-border-color-active);
        }

        //    sizes

        textarea.input__control.input__control_textarea_yes {
            height: 8em !important;
            resize: vertical;
        }

        .input__autogrow {
            display: grid;
            font: inherit;
        }

        .input__autogrow::after {
            content: attr(data-replicated-value) ' ';
            white-space: pre-wrap;
            visibility: hidden;
            padding-bottom: 10px;
            position: relative;
            top: 15px;
        }

        .input__autogrow textarea.input__control.input__control_textarea_yes {
            resize: none;
            overflow: auto;
            position: relative;
            top: 8px;
        }

        .input__autogrow > textarea,
        .input__autogrow::after {
            grid-area: 1 / 1 / 2 / 2;
            line-height: var(--long-text-textarea-line-height);
            font-size: var(--long-text-textarea-font-size);
            max-height: var(--long-text-textarea-max-height);
            overflow: auto;
            word-break: break-word;
        }

        .input__control_autogrow {
            resize: none;
            overflow: auto;
            position: relative;
            top: 8px;
            height: auto;
            overflow: auto;
        }

        .input__autogrow > textarea.input_overflowHidden {
            overflow: hidden;
        }

        .question__label_preset_yandexMorda .input__control {
            height: inherit;
        }
    `;
}
exports.default = default_1;
